<template>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <jet-validation-errors class="mb-4" />

        <div v-if="hasTokenError" class="my-5" >

            <jet-button :class="{'w-full':is_finalize }"
                @click.prevent="$inertia.visit(route('password.request'))">
                <span class="flex flex-row items-center">Ask for a new link <vue-feather type="arrow-right" class="w-4 h-4 ml-2" /></span>
            </jet-button>

        </div>

        <form @submit.prevent="submit" v-else>
            <div>
                <jet-label for="email" value="Email" />
                <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus disabled="is_finalize" />
            </div>

            <div class="mt-4">
                <jet-label for="password" value="Password" />
                <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
            </div>

            <div class="mt-4">
                <jet-label for="password_confirmation" value="Confirm Password" />
                <jet-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="flex items-center justify-end mt-4">
                <jet-button :class="{ 'opacity-25': form.processing, 'w-full':is_finalize }" :disabled="form.processing">
                    <span v-if="is_finalize" class="flex flex-row items-center">Set your password <vue-feather type="arrow-right" class="w-4 h-4 ml-2" /></span>
                    <span v-else>Reset Password</span>
                </jet-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
    import JetButton from '@/Jetstream/Button'
    import JetInput from '@/Jetstream/Input'
    import JetLabel from '@/Jetstream/Label'
    import JetValidationErrors from '@/Jetstream/ValidationErrors'

    export default {
        components: {
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors
        },

        props: {
            email: String,
            token: String,
            is_finalize: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                })
            }
        },
        created() {
            console.log(this.token)
        },
        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            },
            is_token_error() {

            }
        },

        computed: {
            errors() {
                return this.$page.props.errors
            },

            hasErrors() {
                return Object.keys(this.errors).length > 0;
            },

            hasTokenError() {
                if (this.hasErrors) {
                    //console.log(this.errors)
                    //for (const err of this.errors) {
                        if (this.errors.email) {
                            if (this.errors.email.includes("token")) {
                                return true
                            }
                        }
                    //}
                }
                return false
            }
        }
    }
</script>
